import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xB757d27A6C1865B8A66aA9BdD6a67AA8B8355810', // TODO
  [ChainId.BSCTESTNET]: '0x80DfD495C55E0364E1673166Bc14D937263e6c92'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
